// extracted by mini-css-extract-plugin
export default {"error-text":"ImageModal_error-text__Hl8Uj","image-list-wrapper":"ImageModal_image-list-wrapper__FOAKb"};